import { observer } from 'mobx-react'
import React, { Component, Fragment } from 'react'
import styled from 'styled-components'
import Text from '../../components/Text'
import patient from '../../stores/patient'
import Header from './Header'
import NameDate from './NameDate'
import Notes from './Notes'
import Card from '../../components/Card'
import Row from '../../components/Row'
import Input from '../../components/Input'
import Paragraph from "../../components/Paragraph";

const PageBreak = styled.div`
  height: 0;
  page-break-after: always;
`

const NothingToPrint = styled.div`
  font-size: 2rem;
  font-weight: 300;
  text-align: center;
  padding: 4rem 2rem;
`

const Hr = styled.hr`
  width: 100%;
  border-bottom: 0;
  border-top: 2px solid #ccc;
  margin: 1rem 0;
`

@observer
export default class PrintScreening extends Component {
  componentDidMount() {
    window.print()
    window.close()
  }

  render() {
    const nothingToPrint = (
      !patient.fields.patientNotes
    )

    return (
      <Fragment>
        {nothingToPrint &&
          <NothingToPrint>
            <Text str="prose.nothingToPrint" />
          </NothingToPrint>
        }
        {patient.fields.patientNotes &&
          <Fragment>
            <NameDate />
            {patient.fields.patientNotes &&
              <Fragment>
                <Header str="titles.notesForYourDoctor" />
                <Notes>{patient.fields.patientNotes}</Notes>
              </Fragment>
            }
            <PageBreak />
          </Fragment>
        }
        <Card>
          <Card.Title str="titles.appointmentSummary" />
          <Card.Pad>
            <Paragraph str="prose.mayHaveGlaucoma" />
            <Paragraph str="prose.maintainVisionImportant" />
          </Card.Pad>
          {!!patient.fields.screeningSessionSummaryPlan && !!patient.fields.screeningSessionSummaryPlan.trim() && <Fragment>
            <Hr />
            <Card.Pad>
              <Row>
                <Row.Cell flex="1" flexCol><p>You plan to:</p></Row.Cell>
                <Row.Cell flex="4">
                  <pre style={{ whiteSpace: 'pre-wrap' }}>{patient.fields.screeningSessionSummaryPlan}</pre>
                  {/* <TextArea
                    name="screeningSessionSummaryPlan"
                    value={patient.fields.screeningSessionSummaryPlan}
                    disabled
                  ></TextArea> */}
                  {/* <Input name="screeningSessionSummaryPlan" type="text" onChange={patient.setField} value={patient.fields.screeningSessionSummaryPlan} /> */}
                </Row.Cell>
              </Row>
            </Card.Pad>
          </Fragment>}
          {!!patient.fields.screeningSessionSummaryApptDate && <Fragment>
            <Hr />
            <Card.Pad style={{ pageBreakInside: 'avoid' }}>
              <Row>
                <Row.Cell centered flex="1">Appt. date:</Row.Cell>
                <Row.Cell flex="4"><pre style={{ whiteSpace: 'pre-wrap' }}>{patient.fields.screeningSessionSummaryApptDate}</pre></Row.Cell>
              </Row>
            </Card.Pad>
          </Fragment>}
          {!!patient.fields.screeningSessionSummaryProviderLocation && !(patient.fields.screeningSessionSummaryProviderLocation === 'OTHER' && !patient.fields.screeningSessionSummaryProviderAddr1 && !patient.fields.screeningSessionSummaryProviderAddr2) &&
            <Fragment>
              <Hr />
              <Card.Pad style={{ pageBreakInside: 'avoid' }}>
                <Row>
                  <Row.Cell centered flex="1"><p>Location:</p></Row.Cell>
                  <Row.Cell flex="4">
                    <pre style={{ whiteSpace: 'pre-wrap' }}>
                      {patient.fields.screeningSessionSummaryProviderLocation === 'KELLOGG_EYE_CENTER' &&
                        `Kellogg Eye Center\n1000 Wall St, Ann Arbor, MI 48105`
                      }
                      {patient.fields.screeningSessionSummaryProviderLocation === 'HAMILTON_CLINIC' &&
                        `Hamilton Clinic\n2900 N. Saginaw Street, Flint, MI 48505`
                      }
                      {patient.fields.screeningSessionSummaryProviderLocation === 'HOPE_CLINIC' &&
                        `Hope Clinic\n518 Harriet Street, Ypsilanti, MI 48197`
                      }
                      {patient.fields.screeningSessionSummaryProviderLocation === 'OTHER' &&
                        `${patient.fields.screeningSessionSummaryProviderAddr1}\n${patient.fields.screeningSessionSummaryProviderAddr2}`
                      }
                    </pre>
                  </Row.Cell>
                </Row>
              </Card.Pad>
            </Fragment>}        
            {!!patient.fields.screeningSessionSummaryProviderLocation && !(patient.fields.screeningSessionSummaryProviderLocation === 'OTHER' && !patient.fields.screeningSessionSummaryProviderPhone) && <Fragment>
              <Hr />
              <Card.Pad style={{ pageBreakInside: 'avoid' }}>
                <Row alignCenter>
                  <Row.Cell centered flex="1"><Paragraph str="prose.needToCancel"/></Row.Cell>
                  <Row.Cell><Input type="text" name="screeningSessionSummaryCounselorPhone" value={
                    (patient.fields.screeningSessionSummaryProviderLocation === 'KELLOGG_EYE_CENTER' && '(734) 436-1186') ||
                    (patient.fields.screeningSessionSummaryProviderLocation === 'HAMILTON_CLINIC' && '(810) 309-9378') ||
                    (patient.fields.screeningSessionSummaryProviderLocation === 'HOPE_CLINIC' && '(734) 436-1186') ||
                    (patient.fields.screeningSessionSummaryProviderLocation === 'OTHER' && patient.fields.screeningSessionSummaryProviderPhone)
                  } /></Row.Cell>
                </Row>
              </Card.Pad>
            </Fragment>}
        </Card>
      </Fragment>
    )
  }
}



// WEBPACK FOOTER //
// ./src/pages/Print/PrintScreening.js